import { useFormik } from 'formik'
import { PageTitle } from '../../../_metronic/layout/core'
import * as Yup from 'yup'
import { Col, Form, Row, Toast, ToastContainer } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { checkFinalOfferPriceApi, checkOfferPriceApi, locationListApi, productGradeListApi } from './_request'
import { checkDisplayValue } from '../../utils/utils'
import { KTCardBody, KTSVG, showToast } from '../../../_metronic/helpers'
import { OffersListLoading } from '../offer-management/offers-list/components/loading/OffersListLoading'
import download from 'downloadjs'
import axios from 'axios'
import { SERVER_URL } from '../../ServerConfig'
import { useIntl } from 'react-intl'
import { ToastType } from '../../../_metronic/helpers/crud-helper/ToastTypes'
import moment from 'moment'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { checkPermission } from '../../utils/checkPermission';

const OfferWithPrice = () => {
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })
  const [loading, setLoading] = useState(false);
  const [productGroupList, setProductGroupList] = useState<any>([])
  const [selectedProductGroupList, setSelectedProductGroupList] = useState<any>({})
  const [locationList, setLocationList] = useState<any>([])
  const [selectedLocationList, setSelectedLocationList] = useState<any>({ "label": "Ahmedabad", "value": "3cb71b1b-1b44-40d2-8dd7-c85d7b994549" })
  const [offerDetail, setOfferDetail] = useState<any>([])
  const [offerPrice, setOfferPrice] = useState<any>([])
  const [getCityData, setCityData] = useState<any>()
  const intl = useIntl()
  const offerValidation = Yup.object().shape({
    product_group_id: Yup.string()
      .required('Product Group is required'),
    destination_location_id: Yup.string()
      .required('Location is required'),
    quantity: Yup.number()
      .typeError('Quantity must be a number')
      .min(1, 'Minimum 1 MT quantity is required')
      .required('Quantity is required'),
  })

  const formik = useFormik({
    initialValues: {
      product_group_id: 'all',
      destination_location_id: '3cb71b1b-1b44-40d2-8dd7-c85d7b994549',
      quantity: '25',
    },
    validationSchema: offerValidation,
    onSubmit: async (values: any) => {
      await checkOfferPriceApi(values.product_group_id, values.destination_location_id).then(async (data: any) => {
        if (data?.responseStatus == 200 && data?.responseData?.list) {
          let offerData1 = data?.responseData?.list ?? []
          setOfferDetail(offerData1)
          let offerReqData = offerData1.map((x: any) => {
            let i = {} as any
            i.product_group_id = formik.values.product_group_id
            i.offer_id = x.id
            i.qty = formik.values.quantity
            i.destination_location_id = formik.values.destination_location_id
            return i
          })
          let data2 = await checkFinalOfferPriceApi(offerReqData) as any
          if (data2.responseStatus == 200 && data2.responseData) {
            setOfferPrice(data2.responseData)
          }
          else {
            setOfferPrice([])
            setOfferDetail([])
            let message = data2?.responseMessage ? data2?.responseMessage : 'Something went wrong'
            setSessionMessage({ type: 'error', message: message, show: true })
          }
        } else {
          setOfferPrice([])
          setOfferDetail([])
          let message = data?.responseMessage ? data?.responseMessage : 'Something went wrong'
          setSessionMessage({ type: 'error', message: message, show: true })
        }
      }).catch((err: any) => {
        setOfferPrice([])
        setOfferDetail([])
        let message = err?.message
          ? err.message
          : err?.responseMessage
            ? err.responseMessage
            : ('Something went wrong' as any)
        setSessionMessage({ type: 'error', message: message, show: true })
      })
    },
  });

  useEffect(() => {
    if (sessionMessage.show) {
      setTimeout(() => {
        setSessionMessage({
          type: '',
          message: '',
          show: false,
        })
      }, 5000)
    }
  }, [sessionMessage.message])

  const getProductGroupList = async (search: any) => {
    try {
      let { responseStatus, responseMessage, data } = await productGradeListApi(search) as any
      if (responseStatus == 200 && data) {
        let allOption = { label: 'All', value: 'all' };
        let updatedProductGroupList = [
          allOption,
          ...data.map((x: any) => {
            x.label = x.name;
            x.value = x.id;
            return x;
          }),
        ];
        setProductGroupList(updatedProductGroupList);
      } else {
        let message = responseMessage ? responseMessage : 'Something went wrong'
        setSessionMessage({ type: 'error', message: message, show: true })
      }
    } catch (err: any) {
      let message = err?.message
        ? err.message
        : err?.responseMessage
          ? err.responseMessage
          : ('Something went wrong' as any)
      setSessionMessage({ type: 'error', message: message, show: true })
    }
  }

  const getLocationList = async (search: any) => {
    try {
      let { responseStatus, responseData, responseMessage } = await locationListApi(search) as any
      if (responseStatus == 200 && responseData) {
        setLocationList(
          responseData.map((x: any) => {
            x.label = x.name
            x.value = x.id
            setCityData(x?.name)
            return x
          })
        )
      } else {
        let message = responseMessage ? responseMessage : 'Something went wrong'
        setSessionMessage({ type: 'error', message: message, show: true })
      }
    } catch (err: any) {
      let message = err?.message
        ? err.message
        : err?.responseMessage
          ? err.responseMessage
          : ('Something went wrong' as any)
      setSessionMessage({ type: 'error', message: message, show: true })
    }
  }

  const getSelectedProductGroupList = () => {
    if (formik.values.product_group_id === 'all') {
      return [{ label: 'All', value: 'all' }];
    }
    if (selectedProductGroupList.value == formik.values.product_group_id) {
      if (!productGroupList.find((x: any) => x.value == formik.values.product_group_id)) {
        productGroupList.push(selectedProductGroupList)
        setProductGroupList(productGroupList)
      }
      return [selectedProductGroupList]
    } else return []
  }

  const getSelectedLocationList = () => {
    if (selectedLocationList.value == formik.values.destination_location_id) {
      if (!locationList.find((x: any) => x.value == formik.values.destination_location_id)) {
        locationList.push(selectedLocationList)
        setLocationList(locationList)
      }
      return [selectedLocationList]
    } else return []
  }

  const handleExport = async () => {
    setLoading(true);
    try {
      // API call to fetch Excel data
      const selectedLocation = locationList.find(
        (x: any) => x.value === formik.values.destination_location_id
      );

      const exportData = {
        product_group_id: formik.values.product_group_id,
        destination_location_id: formik.values.destination_location_id,
        destination_name: selectedLocation?.label || '',
        qty: formik.values.quantity,
      }
      await axios
        .get(`${SERVER_URL}/offer/export-offer-with-price`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
          },
          params: exportData,
          responseType: 'blob',
        })
        .then(async (res: any) => {
          const content = res.headers['content-type']

          if (content.includes('application/json')) {
            const text = await res.data.text(); // Convert Blob to text
            const jsonResponse = JSON.parse(text); // Parse the JSON response

            // Check if the response contains a status or message
            if (jsonResponse.responseStatus === 400) {
              showToast({ message: jsonResponse.responseMessage, type: ToastType.ERROR, autoClose: 1000 });
              setLoading(false);
              return; // Exit if there's an error
            }
          } else {

            download(res.data, intl.formatMessage({ id: 'OFFER.WITH.PRICE.XLSX' }), content)
          }
          setLoading(false);
        })
    } catch (error) {
      setLoading(false);
      console.log('error', error)
    }
  }
  const handleCopy = (row: any) => {
    const productGrade = productGroupList?.find((x: any) => x.value === formik.values.product_group_id)?.label ?? '-';
    const locationLabel = locationList.find((x: any) => x.value === formik.values.destination_location_id)?.label ?? '-';

    const textToCopy = `  Product Group: ${productGrade}                            
  Grade :- *${row.product_variation} @ ${row.totalPrice}/-kg*
  Rate: for total ${formik.values.quantity} MT.
  Supply: Delivered
  Payment Terms: Pay on Delivery
  Location: ${locationLabel}
  Subject to unsold
  To confirm order reply with *confirm* .`;

    navigator.clipboard.writeText(textToCopy).then(() => {
      showToast({ message: 'Copied to clipboard!', autoClose: 1000 });
    });
  };
  useEffect(() => {
    getProductGroupList('')
    getLocationList('')
    console.log("offerDetail", offerPrice);

  }, [])

  return (
    <>
      {checkPermission('Offer With Price', 'list') ? (
        <>
          <div className="d-flex justify-content-between align-items-center">

            <div className="fw-bold fs-2">Offer With Price</div>
            {checkPermission('Offer With Price', 'export') && (
              <button onClick={() => handleExport()} className="btn fw-bold btn-light-primary me-3">
                <span className="svg-icon svg-icon-2">
                  <KTSVG path="/media/icons/duotune/files/fil018.svg" className="svg-icon-muted" />
                </span>
                {loading ? 'Loading...' : 'Export'}
              </button>
            )}
          </div>
          <div className='card card-body p-12 mt-10'>
            <Row className='mb-5'>
              <Col md={1}>
              </Col>
              <Col md={10}>
                <form
                  className='form w-100'
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id='kt_login_signin_form'
                >
                  <Row className='mb-5'>
                    <Col xl={4}>
                      <Form.Group>
                        <Form.Label className='fw-bold required form-label'>Product Group</Form.Label>
                        <Select
                          options={productGroupList}
                          className='custom_select'
                          classNamePrefix='Select'
                          placeholder='Select Product Group'
                          name='product_group_id'
                          onInputChange={(e: any) => {
                            getProductGroupList(e)
                          }}
                          value={getSelectedProductGroupList()}
                          onChange={(e: any) => {
                            formik.setFieldValue('product_group_id', e.value)
                            setSelectedProductGroupList(e)
                          }}
                        />
                        {formik?.touched?.product_group_id && formik?.errors?.product_group_id && (
                          <div className='fv-plugins-message-container'>
                            <span role='alert' className={'text-danger'}>{formik?.errors?.product_group_id as any}</span>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xl={4}>
                      <Form.Group>
                        <Form.Label className='fw-bold required form-label'>Location</Form.Label>
                        <Select
                          options={locationList}
                          className='custom_select'
                          classNamePrefix='Select'
                          placeholder='Select Location'
                          onInputChange={(e: any) => {
                            getLocationList(e)
                          }}
                          value={getSelectedLocationList()}
                          onChange={(e: any) => {
                            formik.setFieldValue('destination_location_id', e.value)
                            setSelectedLocationList(e)
                          }}
                        />
                        {formik?.touched?.destination_location_id && formik?.errors?.destination_location_id && (
                          <div className='fv-plugins-message-container'>
                            <span role='alert' className={'text-danger'}>{formik?.errors?.destination_location_id as any}</span>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xl={4}>
                      <Form.Group>
                        <Form.Label className='fw-bold required form-label'>Quantity</Form.Label>
                        <Form.Control
                          type='text'
                          className='form-control-solid'
                          placeholder='Enter Quantity'
                          value={formik.values.quantity}
                          onChange={(e: any) => {
                            formik.setFieldValue('quantity', e.target.value.trimStart())
                          }}
                        />
                        {formik.touched.quantity && formik.errors.quantity && (
                          <div className='fv-plugins-message-container'>
                            <span role='alert' className={'text-danger'}>{formik?.errors?.quantity as any}</span>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                    </Col>
                    <Col md={4}>
                      <div className='d-grid mb-10'>
                        <button
                          type='submit'
                          id='kt_sign_in_submit'
                          className='btn btn-primary'
                          disabled={formik.isSubmitting}
                        >
                          {formik.isSubmitting ? "Please Wait..." : "Price"}
                        </button>
                      </div>
                    </Col>
                    <Col md={4}>
                    </Col>
                  </Row>

                  <ToastContainer className='p-3' position={'top-end'}>
                    <Toast
                      show={sessionMessage.show}
                      onClose={() => {
                        setSessionMessage({
                          type: '',
                          message: '',
                          show: false,
                        })
                      }}
                      bg='danger'
                    >
                      <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
                    </Toast>
                  </ToastContainer>
                </form>
                <KTCardBody className='py-4'>
                  <div className='table-responsive'>
                    <table
                      id='kt_table_users'
                      className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer offer-with-price-table'
                    >
                      <thead>
                        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0 bg-light'
                        >
                          <th style={{ width: "20%" }}>
                            Product Variation
                          </th>
                          <th style={{ width: "15%" }}>
                            MFI
                          </th>
                          <th style={{ width: "10%" }}>
                            Price
                          </th>
                          <th style={{ width: "10%" }}>
                            Offer ID
                          </th>
                          <th style={{ width: "8%" }}>
                            Copy
                          </th>
                          <th style={{ width: "20%" }}>
                            Firm Name
                          </th>
                          <th style={{ width: "20%" }}>
                            Created On / Updated On
                          </th>
                        </tr>
                      </thead>
                      <tbody className='text-gray-600 fw-bold'>

                        {offerPrice && offerPrice.length > 0 ? (
                          offerPrice.map((row: any, index: any) => {
                            return (
                              <tr key={index}>
                                {/* <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.product_variation)}</td>
                              <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.mfi_kvalue)}</td>
                              <td>{checkDisplayValue(row?.totalPrice)}</td>
                              <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.offer_number)}</td> */}
                                <td>{checkDisplayValue(row?.product_variation)}</td>
                                <td>{checkDisplayValue(row?.mfi_kvalue)}</td>
                                <td>{checkDisplayValue(row?.totalPrice)}</td>
                                <td>{checkDisplayValue(row?.offer_number)}</td>
                                <td className="text-left">
                                  <i className="fa-solid fa-copy"
                                    style={{ fontSize: '26px', color: 'rgb(13 76 111)' }}
                                    onClick={() => handleCopy(row)}>
                                  </i>
                                </td>
                                <td>{checkDisplayValue(row?.firm_name)}</td>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={
                                    <Tooltip className='py-2 px-2 fs-6'>
                                      {row.updated_at ? 'Updated On' : 'Created On'}
                                    </Tooltip>
                                  }
                                >
                                  <td className="text-nowrap">
                                    {row.updated_at || row.created_at
                                      ? moment(row.updated_at || row.created_at).format('hh:mm A MMMM DD, YYYY')
                                      : 'N/A'}
                                  </td>
                                </OverlayTrigger>
                              </tr>
                            )
                          })
                        ) : (
                          <tr>
                            <td colSpan={8}>
                              <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                No Offers Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>

                    </table>

                  </div>

                  <Col xl={12}>
                    <Col className='justify-content-between'>
                      <div className=' mb-3'>Term & Condition</div>
                      <div >
                        <div className='mb-3'>
                          Product Group:  <strong>{productGroupList.find((x: any) => x.value === formik.values.product_group_id)?.label ?? '-'} </strong>
                        </div>
                        <div className='mb-3'>
                          Rate: for <strong>{formik.values.quantity ? formik.values.quantity : 0} MT.</strong>
                        </div>

                        <div className='mb-3'>
                          Supply: Delivered
                        </div>

                        <div className='mb-3'>
                          Payment Terms: Pay on Delivery
                        </div>

                        <div className='mb-3'>
                          Location:<strong>{locationList.find((x: any) => x.value === formik.values.destination_location_id)?.label ?? '-'}</strong>
                        </div>

                        <div className='mb-3'>
                          Subject to unsold
                        </div>

                        <div>
                          To confirm order reply with <strong>confirm.</strong>
                        </div>
                      </div>
                    </Col>
                  </Col>



                  {formik.isSubmitting && <OffersListLoading />}
                </KTCardBody>
              </Col>
              <Col md={1}>
              </Col>
            </Row>

          </div>

        </>) : ""}
    </>
  )
}
export default OfferWithPrice
